import React from 'react';
import styles from './BetaButton.module.scss';
import { setBetaWelcomeModal, useAppDispatch } from 'app/redux';
import config from 'config';

export const BetaButton: React.FC = () => {
  const dispatch = useAppDispatch();

  return (
    <button
      className={styles['beta-btn']}
      onClick={() => {
        if (config.APP.FUNCTIONALITIES.SHOW_BETA_MODAL.toString() === 'true') {
          dispatch(setBetaWelcomeModal(true));
        }
      }}
    >
      ?
    </button>
  );
};
